import type { HandicapConfig, NewPerioConfig, StrokePlayRules, TiebreakConfig } from './types';

/** 후반 9 → 6 → 3 → 18번 홀 백카운트 */
export const DEFAULT_TIEBREAK: TiebreakConfig = {
  method: 'COUNTBACK',
  segments: [{ lastHoles: 9 }, { lastHoles: 6 }, { lastHoles: 3 }, { lastHoles: 1 }],
  basis: 'FORMAT',
  scope: 'FINAL_ROUND',
  holeOrder: 'CARD',
  handicapFractions: true,
  fallback: 'HOLE_BY_HOLE_BACKWARD',
  playoffPositions: [],
  liveDisplay: 'TIED',
};

export const DEFAULT_NEW_PERIO: NewPerioConfig = {
  hiddenHoleCount: 12,
  multiplier: 1.5,
  factor: 0.8,
  perHoleCap: 'DOUBLE_PAR',
  selection: 'RANDOM',
  hiddenHoles: null,
  seed: null,
};

/** 페리오: 6 hidden holes x 3 (same formula as 신페리오). */
export const DEFAULT_PERIO: NewPerioConfig = {
  ...DEFAULT_NEW_PERIO,
  hiddenHoleCount: 6,
  multiplier: 3,
};

/** Rules of Golf default: a hole not holed out in stroke play is a DQ; no maximum score. */
export const DEFAULT_STROKE_PLAY: StrokePlayRules = {
  incompleteHole: 'DQ',
  maxScore: 'NONE',
  maxScoreN: null,
};

export const DEFAULT_HANDICAP: HandicapConfig = {
  method: 'NONE',
  allowance: 1,
  maxHandicap: null,
  minHandicap: null,
  rounding: 'INTEGER',
  newPerio: null,
};
